export default __webpack_public_path__ + "static/tap-21f7b333d5833eb6341c9a3a5af17652.webp";